import useTranslation from "next-translate/useTranslation";
export default function SocialAuthNotice() {
  const { t } = useTranslation("auth");
  return (
    <p className="mb-5 rounded-lg bg-slate-50 px-4 py-3 text-sm leading-6 text-slate-600">
      {t("socialSignInUnavailable")}
    </p>
  );
}
